import { useState } from 'react';

export const filterKeys = {
  LANGUAGE: 'language',
  LEVEL: 'level',
  SUBJECT: 'subject',
  PARTNER: 'partner',
  LEARNING_PRODUCT: 'learningProduct',
} as const;

export type FilterKeys = typeof filterKeys[keyof typeof filterKeys];
export type FilterState = { [key in FilterKeys]: string };
export const defaultFilterValues = {
  [filterKeys.LANGUAGE]: '',
  [filterKeys.LEVEL]: '',
  [filterKeys.SUBJECT]: '',
  [filterKeys.PARTNER]: '',
  [filterKeys.LEARNING_PRODUCT]: '',
};

const useProductFilterState = () => {
  const [filterValues, setFilterValues] = useState<FilterState>(defaultFilterValues);

  const setFilterValue = (key: FilterKeys, value: string) => {
    setFilterValues((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const resetFilterValues = () => {
    setFilterValues(defaultFilterValues);
  };

  return {
    filterValues,
    setFilterValue,
    resetFilterValues,
  };
};

export default useProductFilterState;
